import { __extends } from "tslib";
import { release, notImplemented } from '@awayfl/swf-loader';
import { axCoerceString, ASObject } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: TextSnapshot
var TextSnapshot = /** @class */ (function (_super) {
    __extends(TextSnapshot, _super);
    function TextSnapshot() {
        return _super.call(this) || this;
    }
    Object.defineProperty(TextSnapshot.prototype, "charCount", {
        // _charCount: number /*int*/;
        get: function () {
            release || notImplemented('public flash.text.TextSnapshot::get charCount');
            return;
            // return this._charCount;
        },
        enumerable: true,
        configurable: true
    });
    TextSnapshot.prototype.findText = function (beginIndex /*int*/, textToFind, caseSensitive) {
        beginIndex = beginIndex | 0;
        textToFind = axCoerceString(textToFind);
        caseSensitive = !!caseSensitive;
        release || notImplemented('public flash.text.TextSnapshot::findText');
        return;
    };
    TextSnapshot.prototype.getSelected = function (beginIndex /*int*/, endIndex /*int*/) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        release || notImplemented('public flash.text.TextSnapshot::getSelected');
        return;
    };
    TextSnapshot.prototype.getSelectedText = function (includeLineEndings) {
        if (includeLineEndings === void 0) { includeLineEndings = false; }
        includeLineEndings = !!includeLineEndings;
        release || notImplemented('public flash.text.TextSnapshot::getSelectedText');
        return;
    };
    TextSnapshot.prototype.getText = function (beginIndex /*int*/, endIndex /*int*/, includeLineEndings) {
        if (includeLineEndings === void 0) { includeLineEndings = false; }
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        includeLineEndings = !!includeLineEndings;
        release || notImplemented('public flash.text.TextSnapshot::getText');
        return;
    };
    TextSnapshot.prototype.getTextRunInfo = function (beginIndex /*int*/, endIndex /*int*/) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        release || notImplemented('public flash.text.TextSnapshot::getTextRunInfo');
        return;
    };
    TextSnapshot.prototype.hitTestTextNearPos = function (x, y, maxDistance) {
        if (maxDistance === void 0) { maxDistance = 0; }
        x = +x;
        y = +y;
        maxDistance = +maxDistance;
        release || notImplemented('public flash.text.TextSnapshot::hitTestTextNearPos');
        return;
    };
    TextSnapshot.prototype.setSelectColor = function (hexColor) {
        if (hexColor === void 0) { hexColor = 16776960; }
        hexColor = hexColor >>> 0;
        release || notImplemented('public flash.text.TextSnapshot::setSelectColor');
        return;
    };
    TextSnapshot.prototype.setSelected = function (beginIndex /*int*/, endIndex /*int*/, select) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        select = !!select;
        release || notImplemented('public flash.text.TextSnapshot::setSelected');
        return;
    };
    // Called whenever the class is initialized.
    TextSnapshot.classInitializer = null;
    return TextSnapshot;
}(ASObject));
export { TextSnapshot };
